import axios from "axios";
import { CARD_SUCCESS,CARD_FAILURE,AXIOS_BASE_URL} from "./types";
import { setAlert } from './setAlert';
import setAuthToken from "../utils/setAuthToken";

axios.defaults.baseURL=AXIOS_BASE_URL
//   card basicDetails post //


export const saveCardDetails =(formData)=> async dispatch=>{
    // const config = {
    //     headers: {
    //         'Content-Type': 'application/json'
    //     }
    // }
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }

    try {
        const res = await axios.post('api/admin/users/card' ,formData );

       console.log(res);
setAlert(res.data.msg,"succcess")
dispatch()
    } catch (err) {
        console.log(err);
        console.log(err.response.data.error)
       // dispatch(setAlert(err.response.data.error, 'danger '))
        dispatch(
            
setAlert(err.response.data.error,"danger")
        )
    }
}